// frontend/src/components/Register.js
import React, { useState } from 'react';
import API_URL from '../config';
import {
  Box, Card, CardContent, TextField,
  Button, Typography, FormControl,
  InputLabel, Select, MenuItem
} from '@mui/material';

export default function Register({ showLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [sector, setSector] = useState('');
  const [message, setMessage] = useState('');
  const [done, setDone] = useState(false);

  const handleSubmit = e => {
    e.preventDefault();
    fetch(`${API_URL}/api/auth/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username: username.trim(), password, sector })
    })
      .then(res => res.json().then(data => ({ status: res.status, body: data })))
      .then(({ status, body }) => {
        if (status === 201) {
          setDone(true);
        } else {
          setMessage(body.message || 'Erro ao registrar');
        }
      })
      .catch(() => setMessage('Falha de conexão.'));
  };

  if (done) {
    return (
      <Card sx={{ maxWidth: 400, mx: 'auto', mt: 8 }}>
        <CardContent sx={{ display: 'grid', gap: 2 }}>
          <Typography variant="h5">Conta criada</Typography>
          <Typography>
            Seu acesso precisa ser ativado por um administrador. Assim que for
            ativado, você poderá entrar com o usuário e a senha cadastrados.
          </Typography>
          <Button variant="contained" onClick={showLogin}>Ir para o login</Button>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ maxWidth: 400, mx: 'auto', mt: 8 }}>
      <CardContent>
        <Typography variant="h5" gutterBottom>Registrar</Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ display: 'grid', gap: 2 }}>
          <TextField
            label="Usuário"
            value={username}
            onChange={e => setUsername(e.target.value)}
            fullWidth
            autoComplete="username"
            inputProps={{ autoCapitalize: 'none', autoCorrect: 'off', spellCheck: false }}
          />
          <TextField
            label="Senha"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            fullWidth
            autoComplete="new-password"
          />
          <FormControl fullWidth>
            <InputLabel id="sector-label">Setor</InputLabel>
            <Select
              labelId="sector-label"
              value={sector}
              label="Setor"
              onChange={e => setSector(e.target.value)}
            >
              <MenuItem value="SAF">SAF</MenuItem>
              <MenuItem value="TI">TI</MenuItem>
            </Select>
          </FormControl>
          <Button type="submit" variant="contained">Registrar</Button>
          {message && <Typography color="error">{message}</Typography>}
          <Button variant="text" onClick={showLogin}>Voltar ao login</Button>
        </Box>
      </CardContent>
    </Card>
  );
}
